import {
  BodyText,
  Button,
  Flex,
  Radio,
  RadioGroup,
} from '@utilitywarehouse/hearth-react';
import { FormikProps, useFormikContext } from 'formik';
import { ReactNode } from 'react';

import { Dialog, DialogActions, DialogID, useDialog } from '@components/Dialog';
import { SaveFormValues } from '@features/SaveForLater/types';
import { useFieldProps } from '@hooks/useFieldProps';
import { BooleanSelection } from '@src/types/index';
import { ReferralLegalFormValues } from '@src/types/yourDetails';

type FormValues = ReferralLegalFormValues &
  Pick<SaveFormValues, 'acceptMarketing'>;

export interface MarketingConsentProps {
  agreeLabel: string;
  declineLabel: string;
  content: ReactNode;
  name: keyof FormValues;
  onClose(): void;
}

const MarketingConsent = ({
  name,
  content,
  agreeLabel,
  declineLabel,
  onClose,
}: MarketingConsentProps) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    submitCount,
    setFieldValue,
  }: FormikProps<FormValues> = useFormikContext();
  const getFieldProps = useFieldProps<FormValues>({
    values,
    errors,
    handleChange,
    handleBlur,
    touched,
    submitCount,
  });

  const dialog = useDialog(DialogID.MARKETING_CONSENT);

  return (
    <Dialog id={dialog.id} onClose={onClose} heading="Are you sure?">
      <Flex direction="column" gap="300">
        <BodyText>{content}</BodyText>
        <RadioGroup
          {...getFieldProps(name)}
          label=""
          onValueChange={(val) => setFieldValue(name, val)}
        >
          <Radio label={declineLabel} value={BooleanSelection.No} />
          <Radio label={agreeLabel} value={BooleanSelection.Yes} />
        </RadioGroup>
      </Flex>
      <DialogActions>
        <Button variant="solid" type="button" onClick={onClose}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { MarketingConsent };
